import { AcceptConditionsClientRequest } from '../../../@types/acceptConditions'
import { ENV } from '../../../Environment'
import { usePolicyholderDetailsStore } from '../../../Stores/policyholderDetailsStore'
import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useGetAdditionalEntityDetailsStore } from '../../../Stores/useGetAdditionalEntityDetailsStore'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'

export const useAcceptConditionsPayload = () => {
  const { createProposal } = useCreateProposalStore()
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const { policyholderAdditionalDetails } = useGetAdditionalEntityDetailsStore()
  const { runPetisSimulation } = useRunPetisSimulationStore()

  const acceptConditionsPayload: AcceptConditionsClientRequest = {
    proposalId: createProposal?.createProposalResponse?.proposalId || '',
    policyHolder: {
      id: policyholderDetailsSelected?.idEntity || '',
      type: policyholderDetailsSelected?.entityType || '',
      email: policyholderAdditionalDetails?.emailContact?.email || '',
      vatNumber: policyholderDetailsSelected?.vatNumber || '',
      phoneContact:
        policyholderAdditionalDetails?.phoneContactList?.[0]?.phoneNumber || '',
      role: '', // TODO: Não tenho esse valor
    },
    consentsListRequest: {
      applicationCode: ENV().ApplicationCode,
      coreSystem: ENV().CoreSystem,
      momentCode: 'P', // TODO: Não tenho esse valor
      processNumber:
        runPetisSimulation?.runPetisSimulationResponse?.quoteId || '',
      policyType: 'A', // TODO: Não tenho esse valor
      productCode: ENV().ProductCode,
    },
  }

  return {
    acceptConditionsPayload,
  }
}
